<div class="support-container">
  <div class="support-nav-bar box">
    <div
      class="support-nav-bar-message message-box img-holder"
      id="setting-box"
      (click)="goToMessage()"
    >
      <img class="message-icon" src="assets/setting/envelope.svg" />
      <ng-container *ngIf="unReadMessage">
        <span
          mat-badge
          class="message-badge"
          *ngIf="unReadMessage.unreadTicketCount > 0"
          >{{ unReadMessage.unreadTicketCount }}</span
        >
      </ng-container>
    </div>
    <div class="support-nav-bar-title">پشتیبانی</div>
    <div class="support-back" (click)="back()">
      <img src="assets/general/back-blue.svg" />
    </div>
  </div>
  <div class="support-holder box">
    <div class="search-box">
      <div class="faq-search">
        <div>
          <img src="assets/general/search.svg" alt="search" />
        </div>
        <input
          type="text"
          [(ngModel)]="searchText"
          (ngModelChange)="search($event)"
          autocomplete="off"
          autofocus
          placeholder="پرسش مورد نظر خود را وارد کنید"
        />
      </div>
    </div>
    <div class="box search-table" *ngIf="!!isSearch">
      <div *ngIf="faqs && faqs.faqs.length == 0">
        <p class="not-found">پرسش مورد نظر پیدا نشد.</p>
      </div>
      <div class="profile-container" *ngIf="faqs && faqs.faqs.length > 0">
        <div
          class="search-cell box"
          *ngFor="let faq of faqs.faqs; let i = index"
          [ngStyle]="{
            'margin-top': i === 0 ? '16px' : '0'
          }"
          (click)="goToAnswer(faq._id)"
        >
          <div class="search-cell-title">{{ faq.question }}</div>
          <img
            class="search-cell-more-icon"
            src="assets/general/left-black.svg"
          />
        </div>
      </div>
    </div>
    <div class="box app-support-table" *ngIf="!isSearch">
      <div *ngFor="let supportTitle of supportTitles" class="profile-container">
        <p>{{ supportTitle.title }}</p>
        <div
          class="app-support-cell box"
          *ngFor="
            let subcategories of supportTitle.subcategories;
            let i = index
          "
          [ngStyle]="{
            'margin-top': i === 0 ? '16px' : '0',
            'border-top': i === 0 ? 'none' : '1px solid #cccccc'
          }"
          (click)="
            supportSelected({ id: subcategories.id, title: subcategories.name })
          "
        >
          <div class="app-support-cell-title">{{ subcategories.name }}</div>
          <img
            class="app-support-cell-more-icon"
            src="assets/general/left-black.svg"
          />
        </div>
      </div>
    </div>
    <div class="box profile-table">
      <div class="profile-cell support-btn box" (click)="support()">
        <div class="profile-cell-button profile-cell-button--blue">
          <img src="assets/setting/support.svg" alt="" />
          <span> تماس با پشتیبانی </span>
        </div>
      </div>
    </div>
  </div>
  <app-edit-bottomsheet
    *ngIf="showEdit"
    [type]="selectedType"
    [faqId]="faqId"
  ></app-edit-bottomsheet>
</div>
